import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Sheet, SheetContent, SheetTitle } from "../../components/ui/sheet";
import BookingWidget from "./BookingWidget";
import { API } from "./bookingParts";

// Any "Book a call" button dispatches `hm:book` (see CalendlyLink); this host opens the branded widget in a sheet.
export const openBooking = (detail = {}) => window.dispatchEvent(new CustomEvent("hm:book", { detail }));

// On-site tools (Renewal Checker / Payment Relief results) already know the lead: mint the same signed token the emails
// use so the widget skips the chooser + qualifiers and lands on the time picker with their details filled in.
export const openPrefilledBooking = async ({ email, name, phone, context, source, path }) => {
  let token = null;
  if (email) {
    token = await fetch(`${API}/api/public/booking/token`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email, name: name || null, phone: phone || null, context, source }) })
      .then((r) => (r.ok ? r.json() : null)).then((d) => d?.token || null).catch(() => null);
  }
  openBooking({ token, context, path });
};

export default function BookingDrawerHost() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [detail, setDetail] = useState({});
  useEffect(() => {
    const on = (e) => { setDetail(e.detail || {}); setOpen(true); };
    window.addEventListener("hm:book", on);
    return () => window.removeEventListener("hm:book", on);
  }, []);
  useEffect(() => { setOpen(false); }, [pathname]);  // a confirmed booking routes to /booked/ — drop the sheet
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent side="right" className="bk-sheet" data-testid="booking-drawer">
        <SheetTitle className="sr-only">{detail.persona === "matt" ? "Book a call with Matt" : "Book a call with Hello Mortgage Team"}</SheetTitle>
        {open && <BookingWidget path={detail.path || window.location.pathname} contextKey={detail.context} persona={detail.persona} token={detail.token || null} />}
      </SheetContent>
    </Sheet>
  );
}
